import type { ShowForRule } from '@art-of-hospitality-solutions-llc/ui-kit/components/content-blocks';

import MultiSelectField, {
  type MultiSelectOption,
} from '../EditorFields/MultiSelectField';
import { withoutEmptyValues } from '../utils';

interface ShowForEditorProps {
  /** The node's current rule (node-level metadata, like the layer name). */
  value?: ShowForRule;
  tagOptions: MultiSelectOption[];
  permissionOptions: MultiSelectOption[];
  roleOptions: MultiSelectOption[];
  /** undefined = rule fully cleared (the node stores no showFor at all). */
  onChange: (rule: ShowForRule | undefined) => void;
}

/**
 * Authors a block's conditional-rendering rule. Enforcement is
 * SERVER-SIDE on the published read path — this panel only writes the
 * rule. Empty selections are pruned so an unrestricted node stores no
 * showFor at all.
 */
export default function ShowForEditor({
  value,
  tagOptions,
  // permissionOptions,
  // roleOptions,
  onChange,
}: ShowForEditorProps) {
  const rule = value ?? {};

  const patch = (axis: keyof ShowForRule, selection: string[]) => {
    const next = withoutEmptyValues({ ...rule, [axis]: selection });
    onChange(Object.keys(next).length > 0 ? (next as ShowForRule) : undefined);
  };

  return (
    <div className="space-y-3">
      <p className="text-xs text-zinc-500">
        Restrict who sees this block in the app. When tags are selected, only
        members with those tags will see the block.
      </p>
      <MultiSelectField
        title="Tags"
        placeholder="Any member"
        options={tagOptions}
        values={rule.tags ?? []}
        onChange={(tags) => patch('tags', tags)}
      />
      {/* <MultiSelectField
        title="Permissions"
        description="Qualifies whether held directly or granted by any of the member's roles."
        placeholder="Any member"
        options={permissionOptions}
        values={rule.permissions ?? []}
        onChange={(permissions) => patch('permissions', permissions)}
      />
      <MultiSelectField
        title="Roles"
        description="Qualifies by role name, regardless of what the role grants."
        placeholder="Any member"
        options={roleOptions}
        values={rule.roles ?? []}
        onChange={(roles) => patch('roles', roles)}
      /> */}
    </div>
  );
}
